let privacy = {
  top: {
    title_1: "A VPN APP that puts your",
    title_2: "Privacy First",
    explain: "Our app is designed to keep your internet connection safe and private, prevent your ISP and"
      + " government from spying on you and the websites you visit from identifying and tracking you, designed to defeat"
      + " censorship and provide a free and open internet for all.",
  },
  download_btn: "Download Rabbit VPN",
  introduce: {
    control: {
      title: "You have control",
      explain: "You have absolute control, including opting out of the exchange at any time, when to"
        + "use the web from your device, and to choose what you are allowed to use and which websites you can access.",
    },
    data_security: {
      title: "Data Security",
      explain: "Rabbit VPN uses the latest encryption technology to protect your data traffic from"
        + " spying. It also does not track or store logs of your browsing history, traffic destination, data content,"
        + " or DNS queries, ensuring that no one can access your data and information."
    },
    privacy_security: {
      title: "Privacy Security",
      explain: "Rabbit VPN does not require any of your personal data, nor does it require a credit"
        + " card or email address, and we strictly comply with all relevant data protection legal requirements,"
        + " including the new EU data protection regulatory framework - GDPR and the California Consumer Privacy Act"
        + " of 2018 - CCPA. We know your IP address just like any other VPN, but Rabbit VPN will pay for your service"
        + " to access the network when your device is available."
    },
    manual_security: {
      title: "Manual Service",
      explain: "Any other concerns? We have teams that can solve any problems you have in 7*24 hours."
        + " You can contact us at any time."
    }
  }
}
export default privacy


// WEBPACK FOOTER //
// ./src/assets/lang/en/new_privacy/index.js